import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Button } from '@lwt-helix/buttons';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { inbox } from '@lwt-helix/helix-icon/outlined';
import { buttonTerms, TimePeriods } from '../../../constants';
import { filterIds, popoverIds, searchfilterStateId, tabs, timeFrameToGrowthPeriod } from '../../constants/suggestedAgents';
import { useSearchStore } from '../../../store/search/store';
import { getHasResults } from './helpers/helpers';
import { exportCsv } from '../common/exportCsv';
import { useCommonStore } from '../../../store/store';
import { getSearchFiltersByTab } from './helpers/searchFilters';

export const SearchFilters = ({ setSuggestedAgentsState, suggestedAgentsState, tableSettings }) => {
    const timeIntervals = useCommonStore(state => state.timeIntervals);
    const {
        currentTabId,
        searchOptions,
        growthAnalysisPeriod,
        setSearchFilterState,
        selectedListingViewId,
        currentTimeFrame,
    } = useSearchStore(state => {
        const { [state.selectedModule] : moduleState, setSearchFilterState } = state;
        const currentTabId = moduleState?.currentTabId;
        const searchOptions = moduleState?.searchOptions;
        const currentTabState = moduleState?.searchOptions?.[currentTabId];
        const isIncDecProducers =
            currentTabId === tabs.incProducers.id || currentTabId === tabs.decProducers.id;
        const growthAnalysisPeriod = isIncDecProducers
            ? currentTabState?.producers?.growthTimeFrame?.value
            : currentTabState?.growthAnalysisPeriod?.value;
        return ({
            currentTabId: currentTabId,
            searchOptions: searchOptions,
            growthAnalysisPeriod,
            setSearchFilterState,
            selectedListingViewId: currentTabState?.display.selectedView.value,
            currentTimeFrame: currentTabState?.producers?.timeFrame?.value,
        })
    });

    const hasResults = getHasResults(suggestedAgentsState?.rowDataByTab[currentTabId]);

    const [ state, setState ] = useState({
        shouldShowPopoverById: {
            [popoverIds.display]: false,
            [popoverIds.metrics]: false,
            [popoverIds.producers]: false,
            [popoverIds.growthAnalysisPeriod]: false,
        },
    });

    const togglePopover = popoverId => {
        setState(prevState => ({
            ...prevState,
            shouldShowPopoverById: {
                ...prevState.shouldShowPopoverById,
                [popoverId]: !prevState.shouldShowPopoverById[popoverId]
            }
        }));
    };

    const isIncOrDecProducersTab = currentTabId === tabs.incProducers.id || currentTabId === tabs.decProducers.id;
    const setGrowthAnalysisPeriod = period => setSearchFilterState(period, filterIds.growthAnalysisPeriod, searchfilterStateId.value);

    useEffect(() => {
        if (isIncOrDecProducersTab) {
            setGrowthAnalysisPeriod(timeFrameToGrowthPeriod[currentTimeFrame]);
        }
    }, [isIncOrDecProducersTab]);

    const handleExportCsv = () => exportCsv(
        {...suggestedAgentsState,
            growthAnalysisPeriod: growthAnalysisPeriod,
            listingProfColumns: suggestedAgentsState.listingProficiencyColumns,
            timeIntervals
        },
        setSuggestedAgentsState,
        selectedListingViewId,
        suggestedAgentsState.rowDataByTab[currentTabId].results,
        currentTabId
    );

    return (
        <div className='d-flex justify-content-center align-items-center px-2'>
            {getSearchFiltersByTab({
                tabKey: currentTabId,
                shouldShowPopoverById: state.shouldShowPopoverById,
                togglePopover,
                searchOptions,
                growthAnalysisPeriod,
                setGrowthAnalysisPeriod,
                setState: setSuggestedAgentsState,
                suggestedAgentsState,
                hasResults,
                tableSettings,
                selectedListingViewId,
            })}
            {hasResults && <Button
                color='secondary'
                dataLwtId='suggested-agents-download-btn'
                id='suggested-agents-download-btn'
                size='sm'
                onClick={handleExportCsv}
            >
                <div className='d-flex align-items-center'>
                    <HelixIcon icon={inbox} className='mr-2' />
                    <span className='text-capitalize'>
                        {buttonTerms.download}
                    </span>
                </div>
            </Button>}
        </div>
    )
};

SearchFilters.propTypes = {
    setSuggestedAgentsState: PropTypes.func,
    suggestedAgentsState: PropTypes.object,
    tableSettings: PropTypes.object,
};

